import profile from "../../../Assets/icon/profile.svg";
import resume from "../../../Assets/icon/resume.svg";
import weekly from "../../../Assets/icon/weekly.svg";
import setting from "../../../Assets/icon/settings.svg";

export const ProfileMenuItems = (currentPath) => {
  return [
    {
      key: 0,
      name: "پروفایل",
      value: "profile",
      path: "/",
      absloutePath: "/profile/",
      neededRole: ["Teacher", "Student"],
      icon: profile,
      toggle: false,
      hasSubCategory: false,
      subCategories: [],
    },
    {
      key: 2,
      name: "قیمت و زمانبندی کلاس",
      value: "weekly",
      path: "/weekly",
      absloutePath: "/profile/weekly",
      neededRole: ["Teacher"],
      icon: weekly,
      hasSubCategory: true,
      subCategories: [
        {
          name: "قیمت کلاس",
          value: "lessons",
          path: "/lessons",
          absloutePath: "/profile/lessons",
        },
        {
          name: "برنامه هفتگی",
          value: "weekly",
          path: "/weekly",
          absloutePath: "/profile/weekly",
        },
        {
          name: "تقویم",
          value: "calendar",
          path: "/calendar",
          absloutePath: "/profile/calendar",
        },
      ],
      toggle: [
        "/profile/lessons",
        "/profile/weekly",
        "/profile/calendar",
      ].includes(currentPath),
    },
    {
      key: 3,
      name: "تنظیمات",
      value: "setting",
      path: "/setting",
      absloutePath: "/profile/setting",
      neededRole: ["Teacher", "Student"],
      icon: setting,
      hasSubCategory: false,
      toggle: false,
      subCategories: [],
    },
  ];
};
